import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Typography,
} from 'antd';
import getQueryParams from 'utils/getQueryParams';
import { verificarEmail } from 'api/usuarios/auth';
import Card from './components/Card';
import './index.scss';

const { Text } = Typography;

const ActivarCuenta = () => {
  const history = useHistory();
  const [respuesta, setRespuesta] = useState([]);

  useEffect(() => {
    let mounted = true;
    const verify = async () => {
      const codigo = getQueryParams('codigo', window.location.href);
      if (!codigo) {
        history.push('/');
      }
      const verified = await verificarEmail(codigo);
      if (mounted) {
        setRespuesta(verified
          ? 'Tu cuenta a sido activada con éxito presiona Continuar para iniciar en SIR.'
          : 'Lo sentimos. Ha ocurrido un proceso inesperado, vuelva a intentarlo.');
      }
    };
    verify();
    return () => { mounted = false; };
  }, []);

  return (
    <Card>
      <Text style={{ textAlign: 'center' }}>
        {respuesta}
      </Text>
      <br />
      <Button
        onClick={() => history.push('/')}
        className="auth-button"
      >
        Continuar
      </Button>
    </Card>
  );
};

export default ActivarCuenta;
